export const LIGHT_GREY = [224, 224, 224];
export const RED = [217, 29, 32];
export const LIGHT_RED = [238, 131, 54];
export const ORANGE = [255, 196, 0];
export const LIGHT_GREEN = [151, 211, 86];
export const GREEN = [30, 155, 71];
